
export function preLoadWallpapers() {
    const wallpaperList = [
        require('@/assets/wallpaper/wallpaper204.png'),
        require('@/assets/wallpaper/wallpaper6.png'),
        require('@/assets/wallpaper/wallpaper1001.png'),
        require('@/assets/wallpaper/wallpaper183.png'),
        require('@/assets/wallpaper/wallpaper4209.png'),
    ];
    loadImage(wallpaperList);
}

export function loadImage(imagesList) {
    for(let i = 0; i < imagesList.length; i++) {
        const img = new Image()
        img.src = imagesList[i]
    }
}